import { createContext, useContext, useRef } from "react";

const RefContext = createContext(null);

export const useRootRef = () => {
  const context = useContext(RefContext);
  if (!context) {
    throw new Error("useRootRef must be used within a RefProvider");
  }
  return context;
};

export const RefProvider = ({ children, root }) => {
  const rootRef = useRef(root);

  return <RefContext.Provider value={rootRef}>{children}</RefContext.Provider>;
};
